

export const SchoolForm={
    id:"",
    code:"",
    name:"",
    acronym:"",
    phone:"",
    postal_box:"",
    email:"",
    logo:"",
    description:""
}